import { gql } from '@apollo/client';

export const DELETE_TRIP = gql`
  mutation DeleteTrip($id: Int!) {
    deleteTrip(id: $id) {
      id
    }
  }
`;

export const CREATE_TRIP = gql`
    mutation CreateTrip($input: CreateTripInput!) {
        createTrip(input: $input) {
            id
        }
    }
`;

export const UPDATE_TRIP = gql`
    mutation UpdateTrip($id: Int!, $input: UpdateTripInput!) {
        updateTrip(id: $id, input: $input) {
            id
        }
    }
`;

export const CREATE_RETURN_TRIP = gql`
    mutation CreateReturnTrip($originalTripId: Int!) {
        createReturnTrip(originalTripId: $originalTripId) {
            id
            departureLocation
            arrivalLocation
            departureDateTime
            linkedTripId
        }
    }
`;

export const START_TRIP = gql`
    mutation StartTrip($id: Int!) {
        startTrip(id: $id) {
            id
            status
        }
    }
`;

export const END_TRIP = gql`
    mutation EndTrip($id: Int!) {
        endTrip(id: $id) {
            id
            status
        }
    }
`;

export const CANCEL_TRIP = gql`
    mutation CancelTrip($id: Int!) {
        cancelTrip(id: $id) {
            id
            status
        }
    }
`;

export const ADD_TRIP_PHOTO = gql`
    mutation AddTripPhoto($tripId: Int!, $phase: TripPhotoPhase!, $order: Int!, $photo: String!) {
        addTripPhoto(tripId: $tripId, phase: $phase, order: $order, photo: $photo) {
            id
            phase
            order
            photo
            createdAt
        }
    }
`;

export const REMOVE_TRIP_PHOTO = gql`
    mutation RemoveTripPhoto($id: Int!) {
        removeTripPhoto(id: $id)
    }
`;

export const GENERATE_TRIP_SHARE_TOKEN = gql`
    mutation GenerateTripShareToken($tripId: Int!) {
        generateTripShareToken(tripId: $tripId) {
            shareUrl
            expiresAt
        }
    }
`;

export const UPDATE_DRIVER_LOCATION = gql`
    mutation UpdateDriverLocation($input: UpdateDriverLocationInput!) {
        updateDriverLocation(input: $input) {
            id
            latitude
            longitude
            timestamp
            tripId
        }
    }
`;

export const START_TRIP_PAUSE = gql`
    mutation StartTripPause($tripId: Int!, $durationMinutes: Int) {
        startTripPause(tripId: $tripId, durationMinutes: $durationMinutes) {
            id
            pauses {
                id
                startedAt
                durationMinutes
                endedAt
            }
        }
    }
`;

export const END_TRIP_PAUSE = gql`
    mutation EndTripPause($tripId: Int!) {
        endTripPause(tripId: $tripId) {
            id
            pauses {
                id
                startedAt
                durationMinutes
                endedAt
            }
        }
    }
`;
